import { errorMessagesProxy } from "@/utils/helpers";

export const CALENDAR_ERRORS = errorMessagesProxy({
  GENERIC_ERROR: "Sorry, there has been a problem with your tee times.",

  PACKAGE_NOT_FOUND:
    "Sorry, we can't find this golf break. Please try a different package.",
});

export const MAX_MONTHS_TO_DISPLAY = 18;

export const DEFAULT_MIN_GROUP_TO_FORCE_BOOK = 2;

export const TTA_UNAVAILABLE_ERROR_KEY = "TTA Unavailable";
